(function flexible(window, document) {
  const docEl = document.documentElement
  let setRemTimer

  function setBodyFontSize() {
      if (document.body) {
          document.body.style.fontSize = `${12 * (window.devicePixelRatio || 1)}px`
      } else {
          document.addEventListener('DOMContentLoaded', setBodyFontSize)
      }
  }

  function isMobile() {
      return window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  }

  function setRemUnit() {
      setBodyFontSize()
      const rem = isMobile() ? docEl.clientWidth / 5 : 75
      window.$rootFontSize = rem
      docEl.style.fontSize = `${rem}px`
  }

  setRemUnit()

  window.addEventListener('resize', () => {
      setRemTimer && clearTimeout(setRemTimer)
      setRemTimer = setTimeout(setRemUnit, 50)
  })
  window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
          setRemUnit()
      }
  })
}(window, document))
